import { differenceInCalendarDays } from "date-fns";
import noun from "plural-ru";

export const useNightsCounter = ({ from, to }: { from?: Date; to?: Date }) => {
  const nights = from && to && differenceInCalendarDays(to, from);
  const word = nights && noun(nights, 'ночь', 'ночи', 'ночей');

  return `${String(nights)} ${word}`;
};
